import {Component, OnDestroy, OnInit} from "@angular/core";
import {ActivatedRoute} from "@angular/router";
import {PostModel, postModelFactory} from "./post.model";
import {Http, RequestOptions} from "@angular/http";
import {environment} from "../environments/environment";
import {Subscription} from "rxjs/Subscription";

@Component({
  templateUrl: './post.component.html',
  styleUrls: ['./post.component.css'],
})
export class PostComponent implements OnInit, OnDestroy {
  post: PostModel = postModelFactory();
  sub: Subscription;

  constructor(private route: ActivatedRoute, private http: Http) {}

  loadPost(id) {
    return this.http.post(
      `${environment.httpBase}/posts/${id}`,
      {},
      new RequestOptions({withCredentials: true}),
    ).toPromise();
  }

  ngOnInit() {
    this.sub = this.route.params.subscribe((params) => {
      if (params.id) {
        this.loadPost(params.id)
          .then(
            (result) => {
              const json = result.json();
              this.post = postModelFactory(json);
            },
            (error) => {
              alert(error);
              console.error(error);
            },
          );
      } else {
        this.post = postModelFactory();
      }
    });
  }

  ngOnDestroy() {
    if (!this.sub) return;
    this.sub.unsubscribe();
  }
}



// WEBPACK FOOTER //
// /var/snowriders/app/src/app/post.component.ts